import React, { Component } from 'react';
import Btn from "../../../Components/Btn";
import { getStatus, getType, cardStatuses } from '../../../config';

export default class ActionBookingPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popupVisible: false
        };
    }
    componentWillMount() {
        document.addEventListener('keydown', e => {
            if (e.keyCode === 27) {
                this.props.toggleFn(e);
            }
        });
    }
    render() {
        let bookingData = this.props.bookingData;

        const bookingStatus = getStatus(bookingData.CardStatusID);
        const bookingType = getType(bookingData.myTrips.length);

        // debugger;
        return (
            <div
            data-status={bookingStatus}
            className={`popup action-booking-popup ${
              this.props.currentBooking ? "popup_visible" : ''
            }`}
          >
            <div className="tbl">
              <div className="tcl">
                <div className="popup__window">
                  <button
                    type="button"
                    className="popup__close material-icons js-popup-closer"
                    onClick={event => this.props.toggleFn(event, this.props.currentBooking)}
                  >
                    close
                  </button>
                  <div className={`action-booking-container ${bookingStatus}`}>
                    {bookingData.CardStatusID === cardStatuses.paid && (
                      <React.Fragment>
                        <label className="label alert">Alert!</label>
                        <h4>Are you sure you want to cancel booking no.{bookingData.CardID}?</h4>
                      </React.Fragment>
                    )}
                    {bookingData.CardStatusID === cardStatuses.pending && (
                      <React.Fragment>
                        <label className="label confirm">Confirm Booking</label>
                        <h4>Are you sure you want to confirm booking no.{bookingData.CardID}?</h4>
                      </React.Fragment>
                    )}
                    <div className="booking-row">
                      <p>
                        <span className={`booking-status ${bookingStatus}`}>{bookingStatus}</span>
                        {bookingData.CardID}
                      </p>
                      <p>
                        {decodeURI(bookingData.UserName)}
                      </p>
                      <p>
                        {bookingData.myTrips[0].TripOfficeFrom}
                        {/* {bookingData.route ? bookingData.route.from : null} - {bookingData.route ? bookingData.route.to : null} */}
                      </p>
                      <p>
                        <strong>{bookingData.CardTotalPrice} EGP</strong>
                        <br/>
                        {bookingType}
                      </p>
                    </div>
                    <div className="btns-actions">
                    {bookingData.CardStatusID === cardStatuses.pending && (
                      <Btn className="btn confirm">Confirm Booking</Btn>
                    )}
                    {bookingData.CardStatusID === cardStatuses.paid && (
                      <React.Fragment>
                        <Btn className="btn simple">No</Btn>
                        <Btn className="btn cancel">Yes! Confirm Delete</Btn>
                      </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}